import { Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import { MARKDOWN_TILLAGG } from '../lib/markdown'
import kursplan from '../statiskt/kursplan.md?raw'
import { useSidTitel } from '../lib/seo'

/** Adressen till ämnessidan hos Skolverket — den auktoritativa källan. */
const SKOLVERKET_URL =
  'https://www.skolverket.se/undervisning/gymnasieskolan/program-och-amnen-i-gymnasieskolan/hitta-program-och-amnen-i-gymnasieskolan-gy25/hitta-program-och-amnen-i-gymnasieskolan-gy25/search/subjects/LEDA?v=1#LEDA'

export default function Kursplan() {
  useSidTitel('Skolverkets kursplan (LEDA, Gy25)')
  return (
    <div className="wrap">
      <article className="dokument">
        {/* Texten i src/statiskt/kursplan.md är ORDAGRANT Skolverkets ämnesplan
            (kontrollerad mot skolverket.se 2026-08-02) — formulera aldrig om den. */}
        <ReactMarkdown remarkPlugins={MARKDOWN_TILLAGG}>{kursplan}</ReactMarkdown>
        <p className="kalla-not">
          Källa:{' '}
          <a href={SKOLVERKET_URL} target="_blank" rel="noopener noreferrer">
            Skolverkets ämnessida för Ledarskap och organisation (LEDA)
          </a>
          , gällande version från 2025-07-01 (Gy25). Ämnesplanen återges här i sin helhet
          och är den grund som läromedlets struktur och lärandemål bygger på.
        </p>
        <p className="kursplan-arkiv-lankar">
          <Link to="/kursplan/gy11">Gamla kursplanen (Gy11, LEDLED0) — arkiverad</Link>
          {' · '}
          <Link to="/kursplan/andringar">Vad har ändrats mellan Gy11 och Gy25?</Link>
        </p>
      </article>
    </div>
  )
}
